<div class="action-tablet-waiting-movement-orders">

  <app-action-tablet-movement-order-list [movementOrders]="movementOrders"></app-action-tablet-movement-order-list>

</div>
